import React, { useState, useEffect } from "react";
import "./App.css";
import "./table-improvements.css";
import Gestores from "./components/Gestores";
import PainelAnalise from "./components/PainelAnalise";
import Login from "./components/Login";
import CadastroUsuario from "./components/CadastroUsuario";
import GerenciadorUsuarios from "./components/GerenciadorUsuarios";

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState("gestores");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showCadastro, setShowCadastro] = useState(false);

  // Verificar se há sessão salva ao carregar a aplicação
  useEffect(() => {
    const savedUser = localStorage.getItem('currentUser');
    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Erro ao carregar dados do usuário:', error);
        localStorage.removeItem('currentUser');
      }
    }
  }, []);

  const pages = {
    gestores: { name: "Gestores", icon: "⚙️", component: Gestores },
    painel: { name: "Painel de Análise", icon: "📊", component: PainelAnalise },
    cadastro: { name: "Cadastrar Usuário", icon: "👤", component: CadastroUsuario },
    gerenciador: { name: "Gerenciar Usuários", icon: "👥", component: GerenciadorUsuarios, adminOnly: true }
  };

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('currentUser', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('currentUser');
    localStorage.removeItem('rememberedUser');
  };

  // Função para verificar se o usuário é administrador
  const isAdmin = () => {
    return user && user.cargo === 'administrador';
  };

  const CurrentComponent = pages[currentPage].component;

  // Se não estiver autenticado, mostrar página de login ou cadastro
  if (!isAuthenticated) {
    if (showCadastro) {
      return <CadastroUsuario onBack={() => setShowCadastro(false)} />;
    }
    return <Login onLogin={handleLogin} onShowCadastro={null} />;
  }

  // Função para navegação entre páginas
  const handleNavigate = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="app-container">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="logo-container">
            <img src="/global_express.png" alt="Global Express Logo" className="sidebar-logo" />
          </div>
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>
        
        <nav className="sidebar-nav">
          {Object.entries(pages)
            .filter(([key, page]) => {
              // Esconder cadastro e gerenciador para operadores
              if ((key === 'cadastro' || key === 'gerenciador') && !isAdmin()) {
                return false;
              }
              // Esconder páginas que requerem admin se não for admin
              if (page.adminOnly && !isAdmin()) {
                return false;
              }
              return true;
            })
            .map(([key, page]) => (
              <button
                key={key}
                className={`nav-item ${currentPage === key ? 'active' : ''}`}
                onClick={() => setCurrentPage(key)}
              >
                <span className="nav-icon">{page.icon}</span>
                {sidebarOpen && <span className="nav-text">{page.name}</span>}
              </button>
            ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">👤</div>
            {sidebarOpen && (
              <div className="user-details">
                <div className="user-name">{user?.nome || 'Empresa'}</div>
                <div className="user-role">ASC: {user?.ascCode || 'N/A'}</div>
                <div className="user-cnpj">{user?.cnpj || ''}</div>
              </div>
            )}
          </div>
          <button 
            className="logout-btn"
            onClick={handleLogout}
            title="Sair do sistema"
          >
            <span className="logout-icon">🚪</span>
            {sidebarOpen && <span className="logout-text">Sair</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <header className="main-header">
          <div className="header-content">
            <h1 className="page-title">
              {pages[currentPage].icon} {pages[currentPage].name}
            </h1>
            <div className="header-actions">
              <div className="user-welcome">
                <span className="welcome-text">Bem-vindo, {user?.nome || 'Empresa'}!</span>
              </div>
              <button className="header-btn" title="Notificações">
                <span>🔔</span>
              </button>
              <button className="header-btn" title="Configurações">
                <span>⚙️</span>
              </button>
              <button 
                className="header-btn logout-header-btn" 
                onClick={handleLogout}
                title="Sair do sistema"
              >
                <span>🚪</span>
              </button>
            </div>
          </div>
        </header>

        <div className="page-content">
          {currentPage === 'painel' ? (
            <CurrentComponent onBack={() => setCurrentPage('gestores')} />
          ) : (
            <CurrentComponent onNavigate={handleNavigate} />
          )}
        </div>
      </main>
    </div>
  );
}